import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  enterVoucherCodeAnchor: {
    id: 'checkout.cartPage.enterVoucherCodeAnchor',
    defaultMessage: 'Enter voucher code',
    description: 'Text for enter voucher code anchor in sticky buttons wrapper',
  },
});
